import React from 'react';
import { wrapEventHandler } from '../../utils/handlers';
import { activities } from '../../utils/activity_util';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import styles from './styles/styles.module.scss';
import proBadgeSvg from './pro-badge.svg';

const HeatmapCheckbox = ({ layerKey, handleHeatmapClick, disabled, checked }) => {
  return (
    <>
      <input
        checked={checked}
        onClick={event => event.stopPropagation()}
        onChange={() => {
          handleHeatmapClick(layerKey);
        }}
        disabled={disabled}
        className={styles.heatmapCheckbox}
        type="checkbox"
      />
      <span className={styles.checkmark} />
    </>
  );
};

const Card = ({
  adminLayout,
  card,
  handleCardClick,
  handleHeatmapClick,
  mobileBrowser,
  handleActivityFilterChange,
  selectedFilterActivity,
  enabledOverlays
}) => {
  let modifierKey = 'Alt';

  try {
    const { platform } = window.navigator;
    if (platform.toLowerCase().indexOf('mac') > -1) {
      modifierKey = 'Opt';
    }
  } catch {
    // noop
  }

  const onSelectChange = e => {
    handleActivityFilterChange(e);
  };

  const renderDropdownSelect = () => {
    const options = activities.map(activity => {
      return (
        <option key={`${card.key}-option-${activity.value}`} value={activity.value}>
          {activity.label}
        </option>
      );
    });
    options.unshift(
      <option key={`${card.key}-option-all`} value="">
        All
      </option>
    );
    return (
      <select value={selectedFilterActivity} onChange={onSelectChange} className={styles.activitySelect}>
        {options}
      </select>
    );
  };

  const renderHeatmapCheckbox = () => {
    if (!(card.hasHeatmap && adminLayout)) {
      return null;
    }

    const layerKey = `${card.key}Heatmap`;

    return (
      <HeatmapCheckbox
        layerKey={layerKey}
        disabled={!card.selected}
        handleHeatmapClick={handleHeatmapClick}
        checked={enabledOverlays.includes(layerKey)}
      />
    );
  };

  const dropdown = ['recordingsAll', 'recordingsPop'].indexOf(card.key) > -1 ? renderDropdownSelect() : null;
  const terrainIndicator =
    card.terrainEnabled && !mobileBrowser ? <span className={styles.terrainAvailable}>{StringConstantsMixin.strings.TERRAIN_AVAILABLE}</span> : null;
  const proBadge =
    card.proRequired && !adminLayout ? (
      <img alt={StringConstantsMixin.strings.NAVIGATION.PRO_BADGE_ALT_TEXT} className={styles.proBadge} src={proBadgeSvg} />
    ) : null;
  const keyboardShortcut =
    adminLayout && !mobileBrowser ? (
      <h4 className={styles.keyboardShortcut}>{card.keyboardShortcut ? `${modifierKey}+${card.keyboardShortcut}` : '\u00A0'}</h4>
    ) : null;
  return (
    <div className={styles.cardContainer}>
      <div
        data-test-id={card.title}
        key={`key-${card.key}`}
        className={`${styles.card} ${card.selected ? styles.selected : ''}`}
        onClick={wrapEventHandler(e => handleCardClick(card, e))}
      >
        {terrainIndicator}
        {dropdown}
        {renderHeatmapCheckbox()}
        {proBadge}
        <img src={card.imgSrc} />
      </div>
      <h3 className={styles.cardTitle}>{card.title}</h3>
      {keyboardShortcut}
    </div>
  );
};

export default Card;
